export const getDriverBulkSendMessagePath = (companyId: number): string =>
  `/api/v1/core/c/${companyId}/drivers/bulk/send-message-to-drivers`;
